import { pusherInitUnauthenticated } from "./base-unauthenticated";
import { PusherMock } from "pusher-js-mock";
export var EVALUATION_FORM_OPEN_EVENT = "App\\Events\\EfButtonVisibility";
export var EVALUATION_FORM_POPUP_OPEN_EVENT = "App\\Events\\EfPopupOpen";
export var subscribeToEvaluationFormPusherChannel = function (_a) {
    var appId = _a.config.appId, evaluationFormEnableCallback = _a.evaluationFormEnableCallback, evaluationFormPopupOpenCallback = _a.evaluationFormPopupOpenCallback;
    if (window === null || window === void 0 ? void 0 : window.Cypress) {
        var pusherInstance = new PusherMock();
        fetch(process.env.PUSHER_BASE_URL + "broadcasting/auth/pusher-unauthenticated", { method: "POST" });
        var channel = pusherInstance.subscribe("".concat(appId, ".none"));
        channel.bind(EVALUATION_FORM_OPEN_EVENT, function (status) {
            evaluationFormEnableCallback(status);
        });
        channel.bind(EVALUATION_FORM_POPUP_OPEN_EVENT, function (status) {
            evaluationFormPopupOpenCallback(status);
        });
        if (window.Cypress) {
            window.Cypress.pusherUnauthenticated = pusherInstance;
        }
        channel.unsubscribe = function () { };
        return channel;
    }
    else {
        var channel = pusherInitUnauthenticated().subscribe("".concat(appId, ".none"));
        channel.bind(EVALUATION_FORM_OPEN_EVENT, function (payload) {
            evaluationFormEnableCallback(payload);
        });
        channel.bind(EVALUATION_FORM_POPUP_OPEN_EVENT, function (status) {
            evaluationFormPopupOpenCallback(status);
        });
        return channel;
    }
};
